import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <PluginOutlet
  @name="bread-crumbs-left"
  @connectorTagName="li"
  @outletArgs={{hash
    tagId=this.tag.id
    additionalTags=this.additionalTags
    noSubcategories=this.noSubcategories
    showTagsSection=this.showTagsSection
    currentCategory=this.category
    categoryBreadcrumbs=this.categoryBreadcrumbs
    editingCategory=this.editingCategory
    editingCategoryTab=this.editingCategoryTab
  }}
/>

{{#each this.categoryBreadcrumbs as |breadcrumb|}}
  {{#if breadcrumb.hasOptions}}
    <li
      style={{if breadcrumb.category (category-variables breadcrumb.category)}}
    >
      <CategoryDrop
        @category={{breadcrumb.category}}
        @categories={{breadcrumb.options}}
        @tagId={{this.tag.id}}
        @editingCategory={{this.editingCategory}}
        @editingCategoryTab={{this.editingCategoryTab}}
        @options={{hash
          parentCategory=breadcrumb.parentCategory
          subCategory=breadcrumb.isSubcategory
          noSubcategories=breadcrumb.noSubcategories
          autoFilterable=true
        }}
      />
    </li>
  {{/if}}
{{/each}}

{{#if this.showTagsSection}}
  {{#if this.additionalTags}}
    <li>
      <TagsIntersectionChooser
        @currentCategory={{this.category}}
        @mainTag={{this.tag.id}}
        @additionalTags={{this.additionalTags}}
        @options={{hash categoryId=this.category.id}}
      />
    </li>
  {{else}}
    <li>
      <TagDrop
        @currentCategory={{this.category}}
        @noSubcategories={{this.noSubcategories}}
        @tagId={{this.tag.id}}
      />
    </li>
  {{/if}}
{{/if}}

<PluginOutlet
  @name="bread-crumbs-right"
  @connectorTagName="li"
  @outletArgs={{hash
    tagId=this.tag.id
    additionalTags=this.additionalTags
    noSubcategories=this.noSubcategories
    showTagsSection=this.showTagsSection
    currentCategory=this.category
    categoryBreadcrumbs=this.categoryBreadcrumbs
    editingCategory=this.editingCategory
    editingCategoryTab=this.editingCategoryTab
  }}
/>
*/
{
  "id": "IJwc34JB",
  "block": "[[[8,[39,0],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"bread-crumbs-left\",\"li\",[28,[37,1],null,[[\"tagId\",\"additionalTags\",\"noSubcategories\",\"showTagsSection\",\"currentCategory\",\"categoryBreadcrumbs\",\"editingCategory\",\"editingCategoryTab\"],[[30,0,[\"tag\",\"id\"]],[30,0,[\"additionalTags\"]],[30,0,[\"noSubcategories\"]],[30,0,[\"showTagsSection\"]],[30,0,[\"category\"]],[30,0,[\"categoryBreadcrumbs\"]],[30,0,[\"editingCategory\"]],[30,0,[\"editingCategoryTab\"]]]]]]],null],[1,\"\\n\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"categoryBreadcrumbs\"]]],null]],null],null,[[[41,[30,1,[\"hasOptions\"]],[[[1,\"    \"],[10,\"li\"],[15,5,[52,[30,1,[\"category\"]],[28,[37,5],[[30,1,[\"category\"]]],null]]],[12],[1,\"\\n      \"],[8,[39,6],null,[[\"@category\",\"@categories\",\"@tagId\",\"@editingCategory\",\"@editingCategoryTab\",\"@options\"],[[30,1,[\"category\"]],[30,1,[\"options\"]],[30,0,[\"tag\",\"id\"]],[30,0,[\"editingCategory\"]],[30,0,[\"editingCategoryTab\"]],[28,[37,1],null,[[\"parentCategory\",\"subCategory\",\"noSubcategories\",\"autoFilterable\"],[[30,1,[\"parentCategory\"]],[30,1,[\"isSubcategory\"]],[30,1,[\"noSubcategories\"]],true]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null]],[1]],null],[1,\"\\n\"],[41,[30,0,[\"showTagsSection\"]],[[[41,[30,0,[\"additionalTags\"]],[[[1,\"    \"],[10,\"li\"],[12],[1,\"\\n      \"],[8,[39,7],null,[[\"@currentCategory\",\"@mainTag\",\"@additionalTags\",\"@options\"],[[30,0,[\"category\"]],[30,0,[\"tag\",\"id\"]],[30,0,[\"additionalTags\"]],[28,[37,1],null,[[\"categoryId\"],[[30,0,[\"category\",\"id\"]]]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,\"li\"],[12],[1,\"\\n      \"],[8,[39,8],null,[[\"@currentCategory\",\"@noSubcategories\",\"@tagId\"],[[30,0,[\"category\"]],[30,0,[\"noSubcategories\"]],[30,0,[\"tag\",\"id\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n\"],[8,[39,0],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"bread-crumbs-right\",\"li\",[28,[37,1],null,[[\"tagId\",\"additionalTags\",\"noSubcategories\",\"showTagsSection\",\"currentCategory\",\"categoryBreadcrumbs\",\"editingCategory\",\"editingCategoryTab\"],[[30,0,[\"tag\",\"id\"]],[30,0,[\"additionalTags\"]],[30,0,[\"noSubcategories\"]],[30,0,[\"showTagsSection\"]],[30,0,[\"category\"]],[30,0,[\"categoryBreadcrumbs\"]],[30,0,[\"editingCategory\"]],[30,0,[\"editingCategoryTab\"]]]]]]],null]],[\"breadcrumb\"],false,[\"plugin-outlet\",\"hash\",\"each\",\"-track-array\",\"if\",\"category-variables\",\"category-drop\",\"tags-intersection-chooser\",\"tag-drop\"]]",
  "moduleName": "discourse/components/bread-crumbs.hbs",
  "isStrictMode": false
});